import React, { ReactNode } from "react";
import classNames from "classnames";
import styles from "./InputNote.module.scss";

interface Props {
  text: string;
  icon?: ReactNode;
  textClassName?: string;
}

const InputNote: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <div className={styles.Container}>
      <div className={styles.TextContainer}>
        <p
          key={props.text}
          className={classNames(styles.Text, props.textClassName)}
        >
          {props.text}
        </p>
      </div>
      {props.icon}
    </div>
  );
};

export default InputNote;
